lmApp
  .directive('lmSearchTokens', ['$templateCache', '$compile', '$timeout', '$window',
    function ($templateCache, $compile, $timeout, $window) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          filters: '=?',
          placeholder: '@',
          search: '=',
          progress: '@',
          block: '@',
          loading: '=?',
          notEmpty: '@?'
        },
        controller: 'LmSearchTokensController',
        link: function (scope, elem, attrs, controller) {
          scope._token_element_ = elem;

          var setDropdownCss = function (e) {
            if (e && e.preventDefault) e.preventDefault();
            if (e && e.stopPropagation) e.stopPropagation();

            scope._dropdown_.css({
              position: 'fixed',
              top: scope._token_element_.offset().top - angular.element(window).scrollTop(),
              left: scope._token_element_.offset().left - angular.element(window).scrollLeft(),
              width: scope._token_element_.width()
            });

            TweenMax.to(scope._dropdown_, 0.350,
              {
                opacity: 1,
                ease: Expo.easeInOut
              });

            $timeout(function () {
              scope._searchField_ = scope._dropdown_.find('input#asset_search');

              scope._searchField_.bind('keydown', function (keyEvent) {
                var key = keyEvent.which;

                if (key === 13) {
                  scope.buildFilters();
                  scope.removeSearchDropdown();
                }

                if (key === 27) {
                  scope.buildFilters();
                  scope.removeSearchDropdown();
                }
              });

              scope._searchField_.focus();
            }, 350);
          };

          scope.showSearchDropdown = function (e) {
            e.stopPropagation();
            e.preventDefault();

            if (scope.loading) return;

            scope.offset = window.pageYOffset;
            scope.keyword = '';

            if (scope.block) angular.element('body').css({
              position: 'fixed',
              width: '100%',
              top: (-1) * scope.offset + 'px'
            });

            scope._token_element_.css({
              opacity: 0
            });

            scope._dropdown_ = $templateCache.get('lm-search-tokens/search-token.dropdown.tpl.html');
            scope._dropdown_ = $compile(scope._dropdown_)(scope);

            scope._dropdown_.appendTo('body');

            scope.$emptyDiv = scope._dropdown_.find('#empty');

            setDropdownCss(e);

            angular.element($window).bind('resize', setDropdownCss);

            scope.$emptyDiv.bind('click', function (data) {
              scope.buildFilters();
              scope.removeSearchDropdown();
            });

            return false;
          };

          scope.removeSearchDropdown = function () {
            scope.isDropped = false;

            if (scope.block) angular.element('body').removeAttr('style');
            angular.element($window).scrollTop(scope.offset);

            angular.element($window).unbind('resize');
            scope.$emptyDiv.unbind('click');

            scope._dropdown_.remove();
            scope._token_element_.css({
              opacity: 1
            });
          };
          
          if (scope.notEmpty) {
            scope.buildFilters();
          }

          scope._token_element_.bind('click', scope.showSearchDropdown);

          scope._token_element_.on('$destroy', function () {
            scope._token_element_.unbind('click', scope.showSearchDropdown);
          });
        },
        templateUrl: 'lm-search-tokens/search-tokens.tpl.html'
      };
    }]);

lmApp
  .controller('LmSearchTokensController', ['$scope', '$rootScope', 'AssetService', '$templateCache', '$compile', '$timeout', '$window', 'ValidatorService',
    function ($scope, $rootScope, AssetService, $templateCache, $compile, $timeout, $window, ValidatorService) {

      $scope.registeredNavigated = [];
      $scope.currentFocused = {};

      var arrayObjectIndexOf = function (arr, obj) {
        for (var i = 0; i < arr.length; i++) {
          if (angular.equals(arr[i], obj)) {
            return i;
          }
        }
        return -1;
      };

      $scope.isDropped = false;

      $scope.searchData = {
        filters: [
          {
            title: 'Categories',
            type: 'category'
          },
          {
            title: 'Genres',
            type: 'genre'
          },
          {
            title: 'Keyword',
            type: 'keyword'
          }
        ],
        loading: false,
        filterGroups: [],
        genres: [],
        categories: [],

        addToSelected: function (token) {
          if (token.type === 'keyword') {
            var prevText = _.find($scope.searchData.filterGroups, {type: 'keyword'});

            if (prevText) {
              $scope.searchData.filterGroups.splice($scope.searchData.filterGroups.indexOf(prevText), 1);
            }
          }

          this.filterGroups.push(token);

          $scope._searchField_.focus();
          $scope.keyword = '';
          //clearNavigated();
        },

        removeFromSelected: function (token) {
          var index = arrayObjectIndexOf($scope.searchData.filterGroups, token);
          if (index !== -1) {
            $scope.searchData.filterGroups.splice(index, 1);
          }
        }
      };

      $scope.isTokens = function (type) {
        return !!$scope.searchData.filterGroups.filter(function (token) {
          return token.type === type;
        }).length;
      };

      $scope.clearFilters = function () {
        $scope.searchData.filterGroups = [];
        $scope.keyword = '';
      };

      $scope.filerCollection = function () {
        return function (value) {
          return $scope.keyword
            && value.title.toLowerCase().match(new RegExp($scope.keyword.toLowerCase(), 'g'))
            && $scope.searchData.filterGroups.indexOf(value) === -1;
        }
      };

      $scope.applyFilters = function (filters) {
        if ($scope.loading || _.isEmpty(filters)) return;

        $rootScope.showLinearProgress($scope.progress);
        $scope.loading = true;

        if (!ValidatorService.Numerical(filters.keyword)) {
          AssetService.SearchByKeyword(filters.keyword, {
            genres: _.map(filters.genres, 'id'),
            categories: _.map(filters.categories, 'id')
          })
            .then(function (collection) {
              $scope.search = collection;
              $rootScope.hideLinearProgress($scope.progress);
              $scope.loading = false;
            })
            .catch(function (reason) {
              $rootScope.hideLinearProgress($scope.progress);
              $scope.loading = false;
            });
        } else {
          AssetService.GetAssetById(filters.keyword)
            .then(function (collection) {
              $scope.search = collection;
              $rootScope.hideLinearProgress($scope.progress);
              $scope.loading = false;
            })
            .catch(function (reason) {
              $rootScope.hideLinearProgress($scope.progress);
              $scope.loading = false;
            });
        }
      };

      $scope.buildFilters = function () {

        var prevText = _.find($scope.searchData.filterGroups, {type: 'keyword'});

        if (prevText && $scope.keyword) {
          $scope.searchData.filterGroups.splice($scope.searchData.filterGroups.indexOf(prevText), 1);
        }

        if ($scope.keyword) {
          $scope.searchData.filterGroups.push({
            type: 'keyword',
            title: $scope.keyword
          });
        }

        var genres = $scope.searchData.filterGroups.filter(function (token) {
          return token.type === 'genre';
        });

        var categories = $scope.searchData.filterGroups.filter(function (token) {
          return token.type === 'category';
        });

        var text = '';
        if ($scope.keyword) {
          text = $scope.keyword;
        } else {
          text = (prevText) ? prevText.title : '';
        }

        $timeout(function () {
          $scope.filters = {
            keyword: text,
            genres: genres,
            categories: categories
          };

          if ($scope.search) $scope.applyFilters($scope.filters);
        })
      };

      AssetService.GetGenresCollection()
        .then(function (collection) {
          $scope.searchData.genres = collection.filter(function (genre) {
            genre.type = 'genre';
            return genre.title !== 'Undefined'
          });
        });

      AssetService.GetCategoryCollection()
        .then(function (collection) {
          $scope.searchData.categories = collection.filter(function (category) {
            category.type = 'category';
            return category.title !== 'Undefined'
          });
        });

      $scope.watcherFilter = $scope.$watchCollection('filters', function (newValue, oldValue) {
        if (newValue && newValue.keyword) {
          var prevText = _.find($scope.searchData.filterGroups, {type: 'keyword'});

          if (prevText) {
            $scope.searchData.filterGroups.splice($scope.searchData.filterGroups.indexOf(prevText), 1);
          }

          $scope.searchData.filterGroups.push({
            type: 'keyword',
            title: newValue.keyword
          });
        }

        if (!newValue.keyword && oldValue.keyword) {
          var prevText = _.find($scope.searchData.filterGroups, {type: 'keyword'});

          if (prevText) {
            $scope.searchData.filterGroups.splice($scope.searchData.filterGroups.indexOf(prevText), 1);
          }
        }
      });
      
      $scope.$on('$destroy', function () {
        $scope.watcherFilter();
      });
    }
  ]);
